<template>
  <!-- NAME -->
  <div>
    <v-container xs12 id="right-container">
      <v-container id="name">
        <v-flex wrap class="center name-bottom">
          <!-- Mobile -->
          <div class="grey--text title hidden-md-and-up">I'm</div>
          <div class="grey--text text--darken-2 display-2 hidden-md-and-up">NuttapatK.</div>
          <!-- Normal -->
          <div class="grey--text display-1 hidden-sm-and-down">I'm</div>
          <div class="grey--text text--darken-2 display-4 hidden-sm-and-down">NuttapatK.</div>
        </v-flex>
      </v-container>
      <!-- Education -->
      <v-container id="edu">
        <div v-for="(str,i) in subheader" :key="i">
          <v-flex wrap text-xs-center xs12>
            <div class="grey--text text--darken-1 subheading hidden-sm-and-down">
              {{str}}
            </div>
            <div class="grey--text text--darken-1 body-1 hidden-md-and-up">
              {{str}}
            </div>
          </v-flex>
        </div>
      </v-container>
      <!-- SOCIAL -->
      <v-container>
        <v-divider class="grey lighten-2" dark></v-divider>
      </v-container>
      <v-container justify-space-between wrap align-center id="contact">
        <v-layout v-bind="binding">
          <v-flex wrap v-for="(c, i) in contact" :key="i"
                  :style="{fontSize:'0.5em', color: '#616161', textAlign: 'center'}"
                  class="expand">
            <i :class="'fas ' + c.icon + ' fa-3x'" class="contact-icon"></i>
            <span class="grey--text text--darken-1 body-1 contact">
              {{c.text}}
              </span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </div>
</template>

<script>
  import json from '../../../data/data.json'
  export default {
    computed: {
      binding() {
        const binding = {}

        if (this.$vuetify.breakpoint.smAndDown) binding.column = true

        return binding
      }
    },
    data() {
      return {
        subheader: json.subheader,
        contact: json.contact,
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  .contact-icon {
    vertical-align: middle;
  }

  .expand {
    padding: 0.5em;
  }

  .contact {
    vertical-align: bottom;
    margin-left: 0.5em;
  }

  .name-bottom {
    align-content: flex-end;
    align-items: stretch;
    /*align-items: baseline;*/ /*Bottom align*/
    /*position: relative;*/
  }

  #outer-right .center {
    display: flex;
    justify-content: center; /* align horizontal */
    /*align-items: center; !* align vertical *!*/
  }

  #outer-left .center {
    display: flex;
    justify-content: center; /* align horizontal */
    /*align-items: center; !* align vertical *!*/
  }


</style>



// WEBPACK FOOTER //
// src/components/desktop/home/Right.vue